import { WorkItemDetail } from "./components/WorkItemDetail";
import { ModuleErrorBoundary } from "@hub/ui/components/ErrorBoundary";

export function WorkItemRoutes() {
  return (
    <ModuleErrorBoundary moduleName="Work Item">
      <WorkItemDetail />
    </ModuleErrorBoundary>
  );
}
